{
  "enum": {
    "IxcRegistrationV1AccountReviewType": {
      "CLEARING_AUTOMATED": "Clearing Automated",
      "CLEARING_MANUAL": "Clearing Manual",
      "DUAL_AUTOMATED": "Dual Automated",
      "DUAL_MANUAL": "Dual Manual",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcRegistrationV1AccountStatus": {
      "OPEN": "Open",
      "PENDING": "Pending",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcRegistrationV1AccountingGroup": {
      "CUSTOMER": "Customer",
      "NON_CUSTOMER": "Non-Customer",
      "PAB": "PAB",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcRegistrationV1BusinessClassification": {
      "MARIJUANA_RELATED_BUSINESS": "Marijuana Related Business",
      "MONEY_SERVICE_BUSINESS": "Money Service Business",
      "NONE": "None",
      "UNSPECIFIED": "Unspecified",
      "VIRTUAL_CURRENCY": "Virtual Currency"
    },
    "IxcRegistrationV1CheckOutcome": {
      "FAILED": "Failed",
      "INCONCLUSIVE": "Inconclusive",
      "PASSED": "Passed",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcRegistrationV1CipOfac": {
      "AML_PARTNERS": "AML Partners",
      "DOW_JONES": "Dow Jones",
      "EQUIFAX": "Equifax",
      "IDOLOGY": "IDology",
      "LEXIS_NEXIS": "Lexis Nexis",
      "PLAID": "Plaid",
      "REFINITIV": "Refinitiv",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcRegistrationV1CipVendor": {
      "EQUIFAX": "Equifax",
      "IDOLOGY": "IDology",
      "ID_ME": "ID Me",
      "JUMIO": "Jumio",
      "LEXIS_NEXIS": "Lexis Nexis",
      "ONFIDO": "Onfido",
      "PLAID": "Plaid",
      "SOCURE": "Socure",
      "TRULIOO": "Trulioo",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcRegistrationV1ClearingControlsSettingsCipProgram": {
      "DISCLOSED": "Disclosed",
      "NONE": "None",
      "UNDISCLOSED": "Undisclosed",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcRegistrationV1ControlsMarginType": {
      "CASH": "Cash",
      "LPM": "LPM",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcRegistrationV1EntityType": {
      "C_CORPORATION": "C Corporation",
      "LIMITED_PARTNERSHIP": "Limited Partnership",
      "LLC_C_CORPORATION": "LLC C Corporation",
      "LLC_PARTNERSHIP": "LLC Partnership",
      "LLC_SINGLE_MEMBER": "LLC Single Member",
      "LLC_S_CORPORATION": "LLC S Corporation",
      "PARTNERSHIP": "Partnership",
      "SOLE_PROPRIETORSHIP": "Sole Proprietorship",
      "S_CORPORATION": "S Corporation",
      "TAX_EXEMPT_CORPORATION": "Tax-Exempt Corporation",
      "TAX_EXEMPT_UNINCORPORATED_BUSINESS": "Tax-Exempt Unincorporated Business",
      "UNINCORPORATED_BUSINESS": "Unincorporated Business",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcRegistrationV1ExemptPayeeCode": {
      "10_COMMON_TR": "10 - Common Trust",
      "11_FINCL_INST": "11 - Financial Institution",
      "12_NOMINEE": "12 - Nominee",
      "13_EXEMPT_TR": "13 - Exempt Trust",
      "1_EXEMPT_ORG": "1 - Exempt Organization",
      "2_US_GVT": "2 - U.S. Government",
      "3_STATE_GVT": "3 - State Government",
      "4_FRGN_GVT": "4 - Foreign Government",
      "5_CORP": "5 - Corporations",
      "6_DEALER": "6 - Dealer",
      "7_FCM": "7 - Futures Commission Merchant",
      "8_REIT": "8 - Real Estate Investment Trust",
      "9_INVMT_CO": "9 - Investment Company",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcRegistrationV1LiquidityNeeds": {
      "DOES_NOT_MATTER": "Does Not Matter",
      "IMPORTANT": "Important",
      "SOMEWHAT_IMPORTANT": "Somewhat Important",
      "UNSPECIFIED": "Unspecified",
      "VERY_IMPORTANT": "Very Important"
    },
    "IxcRegistrationV1MaritalStatus": {
      "DIVORCED": "Divorced",
      "MARRIED": "Married",
      "SINGLE": "Single",
      "UNMARRIED_MINOR": "Unmarried Minor",
      "UNSPECIFIED": "Unspecified",
      "WIDOWED": "Widowed"
    },
    "IxcRegistrationV1Objectives": {
      "ACCUMULATE_WEALTH": "Accumulate Wealth",
      "BALANCED_GROWTH_INCOME": "Balanced Growth Income",
      "CAREER_TRANSITION": "Career Transition",
      "CHARITABLE_GIVING": "Charitable Giving",
      "DEBT_REDUCTION": "Debt Reduction",
      "EDUCATION_EXPENSES": "Education Expenses",
      "EMERGENCY_FUNDS": "Emergency Funds",
      "ESTATE_PLANNING": "Estate Planning",
      "GENERATE_INCOME": "Generate Income",
      "HEALTHCARE_EXPENSES": "Healthcare Expenses",
      "HOME_PURCHASE": "Home Purchase",
      "LARGE_EXPENSE": "Large Expense",
      "LEARNING_TO_INVEST": "Learning to Invest",
      "LONG_TERM_CARE": "Long Term Care",
      "PRESERVE_WEALTH": "Preserve Wealth",
      "RETIREMENT_PLANNING": "Retirement Planning",
      "SPECULATION": "Speculation",
      "STARTING_BUSINESS": "Starting Business",
      "TAX_EFFICIENT_INVESTING": "Tax Efficient Investing",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcRegistrationV1OptionsLevel": {
      "1": "Covered Calls",
      "2": "Long Options",
      "3": "Option Spreads",
      "4": "Naked Contracts",
      "5": "Advanced",
      "NONE": "None",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcRegistrationV1PrincipalStatus": {
      "ACTIVE": "Active",
      "INACTIVE": "Inactive",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcRegistrationV1ProfileStatus": {
      "ACTIVE": "Active",
      "PENDING": "Pending",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcRegistrationV1ProfileVersionStatus": {
      "APPROVED": "Approved",
      "CANCELED": "Canceled",
      "PENDING": "Pending",
      "REJECTED": "Rejected",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcRegistrationV1Purpose": {
      "AVERAGE_PRICE": "Average Price",
      "BILLING": "Billing",
      "CUSTOMER": "Customer",
      "DEPOSIT": "Deposit",
      "INVENTORY": "Inventory",
      "SETTLEMENT": "Settlement",
      "SPECIAL": "Special",
      "TRADE_ERROR": "Trade Error",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcRegistrationV1RegistrationAccountType": {
      "CUSTODIAL": "Custodial",
      "INDIVIDUAL": "Individual",
      "IRA": "IRA",
      "JOINT": "Joint",
      "ORGANIZATION": "Organization",
      "ROTH_IRA": "Roth IRA",
      "SEP_IRA": "SEP IRA",
      "SIMPLE_IRA": "Simple IRA",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcRegistrationV1RegistrationType": {
      "CUSTODIAL": "Custodial",
      "INDIVIDUAL": "Individual",
      "IRA": "IRA",
      "JOINT": "Joint",
      "ORGANIZATION": "Organization",
      "ROTH_IRA": "Roth IRA",
      "SEP_IRA": "SEP IRA",
      "SIMPLE_IRA": "Simple IRA",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcRegistrationV1Relationship": {
      "OTHER": "Other",
      "SPOUSE": "Spouse",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcRegistrationV1Right": {
      "JTWROS": "JTWROS",
      "TIC": "Tenants in Common",
      "UGMA": "UGMA",
      "UNSPECIFIED": "Unspecified",
      "UTMA": "UTMA"
    },
    "IxcRegistrationV1RiskTolerance": {
      "CONSERVATIVE": "Conservative",
      "MODERATE": "Moderate",
      "MODERATELY_AGGRESSIVE": "Moderately Aggressive",
      "MODERATELY_CONSERVATIVE": "Moderately Conservative",
      "SIGNIFICANT_RISK": "Significant Risk",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcRegistrationV1ScreeningTrigger": {
      "CIP_FIELD_UPDATED": "Cip Field Updated",
      "MANUAL_COMPLIANCE_CHECK": "Manual Compliance Check",
      "PROFILE_CREATED": "Profile Created",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcRegistrationV1SummaryStatus": {
      "ACTIVE": "Active",
      "CLOSED": "Closed",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcRegistrationV1TaxIdType": {
      "EIN": "EIN",
      "ITIN": "ITIN",
      "SSN": "SSN",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcRegistrationV1UsState": {
      "AA": "Armed Forces Americas",
      "AE": "Armed Forces Europe",
      "AK": "Alaska",
      "AL": "Alabama",
      "AP": "Armed Forces Pacific",
      "AR": "Arkansas",
      "AS": "American Samoa",
      "AZ": "Arizona",
      "CA": "California",
      "CO": "Colorado",
      "CT": "Connecticut",
      "DC": "District of Columbia",
      "DE": "Delaware",
      "FL": "Florida",
      "GA": "Georgia",
      "GU": "Guam",
      "HI": "Hawaii",
      "IA": "Iowa",
      "ID": "Idaho",
      "IL": "Illinois",
      "IN": "Indiana",
      "KS": "Kansas",
      "KY": "Kentucky",
      "LA": "Louisiana",
      "MA": "Massachusetts",
      "MD": "Maryland",
      "ME": "Maine",
      "MI": "Michigan",
      "MN": "Minnesota",
      "MO": "Missouri",
      "MP": "Northern Mariana Islands",
      "MS": "Mississippi",
      "MT": "Montana",
      "NC": "North Carolina",
      "ND": "North Dakota",
      "NE": "Nebraska",
      "NH": "New Hampshire",
      "NJ": "New Jersey",
      "NM": "New Mexico",
      "NV": "Nevada",
      "NY": "New York",
      "OH": "Ohio",
      "OK": "Oklahoma",
      "OR": "Oregon",
      "PA": "Pennsylvania",
      "PR": "Puerto Rico",
      "RI": "Rhode Island",
      "SC": "South Carolina",
      "SD": "South Dakota",
      "TN": "Tennessee",
      "TX": "Texas",
      "UM": "U.S. Minor Outlying Islands",
      "UNSPECIFIED": "Unspecified",
      "UT": "Utah",
      "VA": "Virginia",
      "VI": "U.S. Virgin Islands",
      "VT": "Vermont",
      "WA": "Washington",
      "WI": "Wisconsin",
      "WV": "West Virginia",
      "WY": "Wyoming"
    }
  },
  "filterEnum": {
    "IxcRegistrationV1AccountQueryServiceAccountListFilterableFields": {
      "accountCode": "Account Code",
      "accountId": "Account",
      "data": {
        "accountingGroup": "Accounting Group",
        "purpose": "Purpose",
        "spec": {
          "!type": "Type",
          "customer": {
            "profileSummaries": {
              "profileId": "Customer Profile"
            },
            "registration": {
              "!type": "Registration Type"
            }
          },
          "platform": {
            "owner": {
              "!type": "Platform Owner Type",
              "profile": {
                "profileId": "Owner Profile",
                "w9": {
                  "signed": "Owner W-9 Signed"
                }
              }
            },
            "profileSummaries": {
              "profileId": "Profile"
            }
          }
        }
      },
      "programId": "Program",
      "status": "Status"
    },
    "IxcRegistrationV1PrincipalQueryServicePrincipalListFilterableFields": {
      "principalId": "Principal",
      "programId": "Program",
      "status": "Status"
    },
    "IxcRegistrationV1ProfileQueryServiceProfileListFilterableFields": {
      "data": {
        "currentVersion": {
          "profile": {
            "!type": "Type",
            "individual": {
              "w9": {
                "signed": "Current Version Individual W-9 Signed"
              }
            },
            "organization": {
              "w9": {
                "signed": "Current Version Organization W-9 Signed"
              }
            }
          }
        },
        "pendingVersion": {
          "profile": {
            "!type": "Pending Version Type",
            "individual": {
              "w9": {
                "signed": "Pending Version Individual W-9 Signed"
              }
            },
            "organization": {
              "w9": {
                "signed": "Pending Version Organization W-9 Signed"
              }
            }
          }
        }
      },
      "profileId": "Profile",
      "programId": "Program",
      "status": "Status"
    },
    "IxcRegistrationV1ProfileVersionQueryServiceProfileVersionListFilterableFields": {
      "data": {
        "profile": {
          "individual": {
            "w9": {
              "signed": "Individual W-9 Signed"
            }
          },
          "organization": {
            "w9": {
              "signed": "Organization W-9 Signed"
            }
          }
        }
      },
      "profileId": "Profile",
      "profileVersionId": "Profile Version",
      "programId": "Program",
      "status": "Status"
    }
  },
  "oneOf": {
    "IxcRegistrationV1AccountCheckType": {
      "clearingAutomatedApproval": "Clearing Automated Approval",
      "clearingManualApproval": "Clearing Manual Approval",
      "programApproval": "Program Approval"
    },
    "IxcRegistrationV1AccountEventType": {
      "accountUpdated": "Account Updated",
      "checkResult": "Check Result",
      "checksPassed": "Checks Passed",
      "clearingAccountUpdated": "Clearing Account Updated",
      "clearingCheckResult": "Clearing Check Result",
      "clearingPlatformUpdated": "Clearing Platform Updated",
      "created": "Created",
      "platformUpdated": "Platform Updated",
      "platformed": "Platformed",
      "profileUpdated": "Profile Updated",
      "specialPurposeCreated": "Special Purpose Created"
    },
    "IxcRegistrationV1AccountEvidence": {
      "programApprovalEvidence": "Program Approval Evidence"
    },
    "IxcRegistrationV1AccountRegistration": {
      "custodial": "Custodial",
      "individual": "Individual",
      "ira": "IRA",
      "joint": "Joint",
      "organization": "Organization",
      "rothIra": "Roth IRA",
      "sepIra": "SEP IRA",
      "simpleIra": "Simple IRA"
    },
    "IxcRegistrationV1AccountRegistrationCustodialGoverningEntity": {
      "usState": "US State"
    },
    "IxcRegistrationV1AccountRegistrationCustodialRights": {
      "ugma": "UGMA",
      "utma": "UTMA"
    },
    "IxcRegistrationV1AccountRegistrationJointRights": {
      "jointTenantsWithRightsOfSurvivorship": "Joint Tenants with Rights of Survivorship",
      "tenantsInCommon": "Tenants in Common"
    },
    "IxcRegistrationV1AccountUpdate": {
      "beneficiaries": "Beneficiaries",
      "controls": "Controls",
      "risk": "Risk",
      "transferOnDeath": "Transfer on Death"
    },
    "IxcRegistrationV1Address": {
      "usAddress": "US Address"
    },
    "IxcRegistrationV1BasicProfile": {
      "naturalPersons": "Natural Persons",
      "organization": "Organization",
      "platform": "Platform"
    },
    "IxcRegistrationV1BeneficialOwner": {
      "direct": "Direct",
      "indirect": "Indirect"
    },
    "IxcRegistrationV1BeneficiaryType": {
      "charity": "Charity",
      "individual": "Individual",
      "trust": "Trust"
    },
    "IxcRegistrationV1CipIdentityEvidenceVendorData": {
      "equifax": "Equifax",
      "idMe": "ID.me",
      "idology": "IDology",
      "jumio": "Jumio",
      "lexisNexis": "LexisNexis",
      "onfido": "Onfido",
      "plaid": "Plaid",
      "socure": "Socure",
      "trulioo": "Trulioo"
    },
    "IxcRegistrationV1CipOfacEvidenceVendorData": {
      "amlPartners": "AML Partners",
      "dowJones": "Dow Jones",
      "equifax": "Equifax",
      "idology": "IDology",
      "interchange": "Interchange",
      "lexisNexis": "LexisNexis",
      "plaid": "Plaid",
      "refinitiv": "Refinitiv"
    },
    "IxcRegistrationV1ClearingAccountEvidence": {
      "clearingAutomatedApprovalEvidence": "Clearing Automated Approval Evidence",
      "clearingManualApprovalEvidence": "Clearing Manual Approval Evidence"
    },
    "IxcRegistrationV1ClearingAccountUpdate": {
      "clearingControls": "Clearing Controls"
    },
    "IxcRegistrationV1ClearingPlatformUpdate": {
      "accountControls": "Account Controls",
      "platformControls": "Platform Controls"
    },
    "IxcRegistrationV1ClearingProfileEvidence": {
      "clearingManualProfileApprovalEvidence": "Clearing Manual Profile Approval Evidence"
    },
    "IxcRegistrationV1ControlPerson": {
      "beneficialOwner": "Beneficial Owner",
      "director": "Director",
      "officer": "Officer",
      "other": "Other"
    },
    "IxcRegistrationV1Employment": {
      "employed": "Full-Time",
      "homemaker": "Homemaker",
      "partTime": "Part-Time",
      "retired": "Retired",
      "seasonal": "Seasonal",
      "selfEmployed": "Self-Employed",
      "student": "Student",
      "unemployed": "Unemployed"
    },
    "IxcRegistrationV1IndividualTaxIdentifier": {
      "itin": "ITIN",
      "ssn": "SSN"
    },
    "IxcRegistrationV1OrganizationTaxIdentifier": {
      "ein": "EIN",
      "ssn": "SSN"
    },
    "IxcRegistrationV1PlatformAccountOwner": {
      "profile": "Profile",
      "program": "Program"
    },
    "IxcRegistrationV1PlatformUpdate": {
      "nickname": "Nickname"
    },
    "IxcRegistrationV1PrincipalEventType": {
      "activated": "Activated",
      "deactivated": "Deactivated"
    },
    "IxcRegistrationV1ProfileCheckType": {
      "cipIdentity": "CIP Identity",
      "cipIdentityMinimal": "CIP Identity Minimal",
      "cipOfac": "CIP OFAC",
      "cipOfacMinimal": "CIP OFAC Minimal",
      "clearingManualProfileApproval": "Clearing Approval"
    },
    "IxcRegistrationV1ProfileEventType": {
      "accountingGroupSet": "Accounting Group Set",
      "created": "Created",
      "resultUpdated": "Result Updated",
      "updateRequested": "Update Requested",
      "updateRolledBack": "Update Rolled Back",
      "versionApproved": "Version Approved",
      "versionRejected": "Version Rejected"
    },
    "IxcRegistrationV1ProfileEvidence": {
      "cipIdentityEvidence": "CIP Identity Evidence",
      "cipIdentityMinimalEvidence": "CIP Identity Minimal Evidence",
      "cipOfacEvidence": "CIP OFAC Evidence",
      "cipOfacMinimalEvidence": "CIP OFAC Minimal Evidence"
    },
    "IxcRegistrationV1ProfileSummaryData": {
      "individual": "Individual",
      "organization": "Organization"
    },
    "IxcRegistrationV1ProfileType": {
      "individual": "Individual",
      "organization": "Organization"
    },
    "IxcRegistrationV1ProfileVersionEventType": {
      "canceled": "Canceled",
      "checkResult": "Check Result",
      "checksPassed": "Checks Passed",
      "clearingCheckResult": "Clearing Check Result",
      "created": "Created",
      "rejected": "Rejected"
    },
    "IxcRegistrationV1PurposeSpec": {
      "customer": "Customer",
      "platform": "Platform"
    },
    "IxcRegistrationV1PurposeSummary": {
      "platform": "Platform",
      "registration": "Registration"
    },
    "IxcRegistrationV1RegistrationDetails": {
      "custodial": "Custodial",
      "individual": "Individual",
      "joint": "Joint"
    }
  },
  "searchEnum": {
    "IxcRegistrationV1AccountQueryServiceAccountListSearchableFields": {
      "data": {
        "displayId": "Display ID",
        "spec": {
          "customer": {
            "profileSummaries": {
              "data": {
                "individual": {
                  "name": {
                    "first": "First Name",
                    "last": "Last Name"
                  }
                },
                "organization": {
                  "legalName": "Organization Legal Name"
                }
              }
            },
            "registration": {
              "individual": {
                "transferOnDeath": {
                  "beneficiaries": {
                    "contingent": {
                      "type": {
                        "individual": {
                          "name": {
                            "first": "First Name",
                            "last": "Last Name"
                          }
                        }
                      }
                    },
                    "primary": {
                      "type": {
                        "individual": {
                          "name": {
                            "first": "First Name",
                            "last": "Last Name"
                          }
                        }
                      }
                    }
                  }
                }
              },
              "ira": {
                "beneficiaries": {
                  "contingent": {
                    "type": {
                      "individual": {
                        "name": {
                          "first": "First Name",
                          "last": "Last Name"
                        }
                      }
                    }
                  },
                  "primary": {
                    "type": {
                      "individual": {
                        "name": {
                          "first": "First Name",
                          "last": "Last Name"
                        }
                      }
                    }
                  }
                }
              },
              "joint": {
                "rights": {
                  "jointTenantsWithRightsOfSurvivorship": {
                    "transferOnDeath": {
                      "beneficiaries": {
                        "contingent": {
                          "type": {
                            "individual": {
                              "name": {
                                "first": "First Name",
                                "last": "Last Name"
                              }
                            }
                          }
                        },
                        "primary": {
                          "type": {
                            "individual": {
                              "name": {
                                "first": "First Name",
                                "last": "Last Name"
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              },
              "rothIra": {
                "beneficiaries": {
                  "contingent": {
                    "type": {
                      "individual": {
                        "name": {
                          "first": "First Name",
                          "last": "Last Name"
                        }
                      }
                    }
                  },
                  "primary": {
                    "type": {
                      "individual": {
                        "name": {
                          "first": "First Name",
                          "last": "Last Name"
                        }
                      }
                    }
                  }
                }
              },
              "sepIra": {
                "beneficiaries": {
                  "contingent": {
                    "type": {
                      "individual": {
                        "name": {
                          "first": " First Name",
                          "last": " Last Name"
                        }
                      }
                    }
                  },
                  "primary": {
                    "type": {
                      "individual": {
                        "name": {
                          "first": "First Name",
                          "last": "Last Name"
                        }
                      }
                    }
                  }
                }
              },
              "simpleIra": {
                "beneficiaries": {
                  "contingent": {
                    "type": {
                      "individual": {
                        "name": {
                          "first": "First Name",
                          "last": "Last Name"
                        }
                      }
                    }
                  },
                  "primary": {
                    "type": {
                      "individual": {
                        "name": {
                          "first": "First Name",
                          "last": "Last Name"
                        }
                      }
                    }
                  }
                }
              }
            }
          },
          "platform": {
            "owner": {
              "profile": {
                "dbaName": "Owner DBA Name",
                "legalName": "Owner Legal Name"
              },
              "program": {
                "legalName": "Program Legal Name"
              }
            },
            "profileSummaries": {
              "data": {
                "individual": {
                  "name": {
                    "first": "Data Spec Platform Profile Summaries Data Individual Name First",
                    "last": "Data Spec Platform Profile Summaries Data Individual Name Last"
                  }
                },
                "organization": {
                  "legalName": "Data Spec Platform Profile Summaries Data Organization Legal Name"
                }
              }
            }
          }
        }
      }
    },
    "IxcRegistrationV1ProfileQueryServiceProfileListSearchableFields": {
      "data": {
        "currentVersion": {
          "profile": {
            "individual": {
              "affiliations": {
                "associatedPersons": {
                  "name": {
                    "first": "First Name",
                    "last": "Last Name"
                  }
                }
              },
              "name": {
                "first": "First Name",
                "last": "Last Name"
              },
              "trustedPersons": {
                "name": {
                  "first": "First Name",
                  "last": "Last Name"
                }
              }
            },
            "organization": {
              "dbaName": "Organization DBA Name",
              "legalName": "Organization Legal Name"
            }
          }
        },
        "pendingVersion": {
          "profile": {
            "individual": {
              "affiliations": {
                "associatedPersons": {
                  "name": {
                    "first": "First Name",
                    "last": "Last Name"
                  }
                }
              },
              "name": {
                "first": "First Name",
                "last": "Individual Last Name"
              },
              "trustedPersons": {
                "name": {
                  "first": "First Name",
                  "last": "Last Name"
                }
              }
            },
            "organization": {
              "dbaName": "Organization DBA Name",
              "legalName": "Organization Legal Name"
            }
          }
        }
      }
    },
    "IxcRegistrationV1ProfileVersionQueryServiceProfileVersionListSearchableFields": {
      "data": {
        "profile": {
          "individual": {
            "affiliations": {
              "associatedPersons": {
                "name": {
                  "first": "First Name",
                  "last": "Last Name"
                }
              }
            },
            "name": {
              "first": "First Name",
              "last": "Last Name"
            },
            "trustedPersons": {
              "name": {
                "first": "First Name",
                "last": "Last Name"
              }
            }
          },
          "organization": {
            "dbaName": "Organization DBA Name",
            "legalName": "Organization Legal Name"
          }
        }
      }
    }
  },
  "sortEnum": {
    "IxcRegistrationV1AccountQueryServiceAccountListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxcRegistrationV1PrincipalQueryServicePrincipalListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxcRegistrationV1ProfileQueryServiceProfileListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxcRegistrationV1ProfileVersionQueryServiceProfileVersionListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    }
  }
}